import { render, staticRenderFns } from "./cabinet-requests-item-content.vue?vue&type=template&id=5956b8a4&scoped=true"
import script from "./cabinet-requests-item-content.vue?vue&type=script&lang=js"
export * from "./cabinet-requests-item-content.vue?vue&type=script&lang=js"
import style0 from "./cabinet-requests-item-content.vue?vue&type=style&index=0&id=5956b8a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5956b8a4",
  null
  
)

export default component.exports